import React, { useEffect, useState } from 'react';
import { BringzzBoxSlider, BringzzButton, BringzzOrder, BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzOrderCard,
    BringzzAccordion
} from "@bringzz/components";
import useRequest from 'hooks/useRequest';
import { ORDER_STATUS } from 'utils/constants';

const OrdersPage = () => {
    const { backPress } = useNavigation();

    const { navigate } = useNavigation();
    const { sendRequest, loading } = useRequest();
    const [orders, setOrders] = useState([])

    const parseDate = (dateString) => {
        // Convert "29.09.2025 13:13" to JavaScript Date
        const [datePart, timePart] = dateString.split(' ');
        const [day, month, year] = datePart.split('.');
        const [hours, minutes] = timePart.split(':');
        return new Date(year, month - 1, day, hours, minutes);
    };

    const fetchOrders = async () => {
        await sendRequest({
            method: 'GET',
            url: `/module/order/getAllOrders`,
        }).then((response) => {
            if (response.status === 'success') {
                const groupedOrders = {
                    accepted: [],
                    inProgress: [],
                    ready: [],
                    completed: []
                };
                
                response.data.forEach(order => {
                    const orderData = {
                        ...order,
                        orderdate: parseDate(order.created)
                    };                    
                    switch(order.deliveryStatus) {
                        case ORDER_STATUS.PHARMACY_MATCHED:
                            groupedOrders.accepted.push(orderData);
                            break;
                        case ORDER_STATUS.BEING_PREPARED:
                        case ORDER_STATUS.SHOPPER_MATCHED:
                        case ORDER_STATUS.SHOPPER_ARRIVED_AT_CUSTOMER:
                        case ORDER_STATUS.SHOPPER_IDENTIFIED_BY_CUSTOMER:
                        case ORDER_STATUS.SHOPPER_ARRIVED_AT_PHARMACY:
                        case ORDER_STATUS.SHOPPER_IDENTIFIED_BY_PHARMACY:
                        case ORDER_STATUS.ORDER_CONFIRMED_BY_PHARMACY:
                        case ORDER_STATUS.ORDER_CONFIRMED_BY_SHOPPER:
                        case ORDER_STATUS.SHOPPER_ARRIVED_AT_CUSTOMER_WITH_PACKAGE:
                        case ORDER_STATUS.SHOPPER_IDENTIFIED_BY_CUSTOMER_WITH_PACKAGE:
                        case ORDER_STATUS.ORDER_CONFIRMED_BY_SHOPPER_WITH_PACKAGE:
                            groupedOrders.inProgress.push(orderData);
                            break;
                        case ORDER_STATUS.PREPARED:
                            groupedOrders.ready.push(orderData);
                            break;
                        case ORDER_STATUS.DONE:
                            groupedOrders.completed.push(orderData);
                            break;
                        default:
                            groupedOrders.accepted.push(orderData);
                    }
                });
                
                setOrders(groupedOrders);
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    useEffect(() => {
        fetchOrders()
    }, [])

    // Loading state
    if (loading) {
        return (
            <BringzzPageContainer
                className="bg-white pb-44"
                header={{
                    left: (
                        <BringzzIcon
                            size='22'
                            icon='IconChevronLeft'
                            folder='LineIcons'
                            className='cursor-pointer'
                            onClick={backPress}
                        />
                    ),
                    title: "My Orders"
                }}
                authenticated={false}
            >
                <div className="flex items-center justify-center p-8">
                    <BringzzIcon
                        size="32"
                        icon="IconSpinner"
                        folder="LineIcons"
                        className="animate-spin text-magic-lilac"
                    />
                </div>
            </BringzzPageContainer>
        );
    }

    return (
        <BringzzPageContainer
            className="bg-white pb-44"
            header={{
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconChevronLeft'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={backPress}
                    />
                ),
                title: "My Orders"
            }}
            footer={
                <div className='h-20 p-5 flex justify-center bg-white'>
                    <BringzzButton
                        size='lg'
                        className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                        onClick={() => navigate("/settings/pharmacy/orders/place")}
                    >
                        Scan now
                    </BringzzButton>
                </div>
            }
            authenticated={false}
            footerHover={true}
        >
            <div>
                {(!orders.accepted && !orders.inProgress && !orders.ready && !orders.completed) ? (
                    <div className="flex flex-col items-center justify-center p-8 text-center">
                        <BringzzIcon
                            size="48"
                            icon="IconShoppingBag"
                            folder="LineIcons"
                            className="text-gray-400 mb-4"
                        />
                        <BringzzText tag="h3" className="text-gray-600 mb-2">No Orders Yet</BringzzText>
                        <BringzzText className="text-gray-500">Orders from customers will appear here</BringzzText>
                    </div>
                ) : (
                    <>
                        <div className='px-6 divide-y '>
                            {[{
                                status: "accepted",
                                label: "Accepted"
                            },
                            {
                                status: "inProgress",
                                label: "In Progress"
                            },
                            {
                                status: "ready",
                                label: "Ready"
                            }
                            ].map((statusObj, indx) => {
                                return orders[statusObj.status] && <div className='' key={indx}>
                                    <BringzzAccordion
                                        separated={false}
                                        title={statusObj.label}
                                        defaultValue={true}
                                    >
                                        <BringzzBoxSlider>
                                            {orders[statusObj.status].map((order, index) => {
                                                return <BringzzOrder
                                                    key={index}
                                                    mode={statusObj.status === 'accepted' ? 1 : 2}
                                                    orderDetails={{
                                                        status: statusObj.status,
                                                        avatar: "",
                                                        date: new Date(order.orderdate),
                                                        name: order.customerName
                                                    }}
                                                >
                                                </BringzzOrder>
                                            })}
                                        </BringzzBoxSlider>
                                    </BringzzAccordion>
                                </div>
                            }
                            )}
                        </div>
                        {orders.completed &&
                            <div className='bg-sand px-6 pb-8'>
                                <div className='flex justify-between items-center'>
                                    <BringzzText tag='h3' className={"my-4"}>Recently Completed </BringzzText>
                                    <BringzzText tag='h5' className={"text-magic-lilac cursor-pointer"} onClick={() => navigate("/settings/pharmacy/orders/completed")}>Show All</BringzzText>
                                </div>
                                <div className='space-y-4'>
                                    {orders.completed.map(((order, index) => {
                                        return <div key={index}>
                                            <BringzzOrderCard
                                                orderDetails={{
                                                    name: order.customerName,
                                                    date: new Date(order.orderdate),
                                                    status: 'Completed',
                                                    price: parseFloat(order.price || 0).toFixed(2),
                                                    itemsCount: order.products.length
                                                }}
                                                onClick={() => navigate(`/settings/pharmacy/orders/view/${order.integrationId}`)}
                                            ></BringzzOrderCard>
                                        </div>
                                    }))}
                                </div>
                            </div>
                        }
                    </>
                )}
            </div>
        </BringzzPageContainer >
    );
};

export default OrdersPage;
